import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const PageTracker = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash || hash.includes('session_id')) return undefined;
    let tries = 0;
    const t = setInterval(() => {
      const el = document.getElementById(hash.slice(1));
      if (el || ++tries > 40) { clearInterval(t); el?.scrollIntoView({ behavior: 'smooth' }); }
    }, 100);
    return () => clearInterval(t);
  }, [pathname, hash]);
  useEffect(() => {
    fetch(`${API_URL}/api/track`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ path: pathname }), keepalive: true }).catch(() => {});
  }, [pathname]);
  return null;
};
